export default "__VITE_ASSET__ConBaXnS__"